class CollectionComponent extends HTMLElement {
    constructor() {
        super()
        this.selectors = {
            collectionWrapper: '.js-collection-wrapper',
            buttonSwitcherGrid: '.js-button-switcher-grid',
            buttonSwitcherList: '.js-button-switcher-list',
            buttonSwitcherGridMobile: '.js-button-switcher-grid-mobile',
            buttonSwitcherListMobile: '.js-button-switcher-list-mobile'
        };

        this.container = this;
        this.collectionWrapper = this.container.querySelector(this.selectors.collectionWrapper);
        this.buttonSwitcherGrid = this.container.querySelector(this.selectors.buttonSwitcherGrid);
        this.buttonSwitcherList = this.container.querySelector(this.selectors.buttonSwitcherList);
        this.buttonSwitcherGridMobile = this.container.querySelector(this.selectors.buttonSwitcherGridMobile);
        this.buttonSwitcherListMobile = this.container.querySelector(this.selectors.buttonSwitcherListMobile);

        this.initCollection();
    }

    initCollection() {
        this.attachListeners();
        this.layoutSwitcher();
    }

    attachListeners() {
        /*
        * Throttling is not needed here, because it is not an expensive computation
        */


    }

    layoutSwitcher() {

        document.addEventListener("DOMContentLoaded", () => {
            if (!this.collectionWrapper) {
                return null
            }

            this.container.customDelegate("click", this.selectors.buttonSwitcherGrid, () => {
                this.collectionWrapper.classList.remove("list-layout");
                this.collectionWrapper.classList.add("grid-layout");

                this.buttonSwitcherGrid.classList.add("active");
                this.buttonSwitcherList.classList.remove("active");
            });

            this.container.customDelegate("click", this.selectors.buttonSwitcherList, () => {
                this.collectionWrapper.classList.remove("grid-layout");
                this.collectionWrapper.classList.add("list-layout");

                this.buttonSwitcherList.classList.add("active");
                this.buttonSwitcherGrid.classList.remove("active");
            });

            this.container.customDelegate("click", this.selectors.buttonSwitcherListMobile, () => {
                this.collectionWrapper.classList.remove("grid-layout");
                this.collectionWrapper.classList.add("list-layout");

                this.buttonSwitcherListMobile.classList.add("active");
                this.buttonSwitcherGridMobile.classList.remove("active");
            });

            this.container.customDelegate("click", this.selectors.buttonSwitcherGridMobile, () => {
                this.collectionWrapper.classList.remove("list-layout");
                this.collectionWrapper.classList.add("grid-layout");

                this.buttonSwitcherGridMobile.classList.add("active");
                this.buttonSwitcherListMobile.classList.remove("active");
            });

        });
    }
}

customElements.define('main-collection', CollectionComponent);